import React from 'react';
import { Link } from 'react-router-dom';
import AnimeCard from '../AnimeCard/AnimeCard';
import styles from './AnimeGrid.module.css';

const AnimeGrid = ({ animeList, viewAllLink, title, showViewAll = true, maxItems = 6 }) => {
  const displayedAnime = maxItems > 0 ? animeList.slice(0, maxItems) : animeList;

  if (!animeList || animeList.length === 0) {
    return (
      <div className={styles.emptyState}>
        <p>No anime found</p>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      {title && (
        <div className={styles.header}>
          <h2 className={styles.title}>{title}</h2>
          {showViewAll && viewAllLink && (
            <Link to={viewAllLink} className={styles.viewAll}>
              View All <span className={styles.viewAllIcon}>→</span>
            </Link>
          )}
        </div>
      )}
      
      <div className={styles.grid}>
        {displayedAnime.map((anime) => (
          <AnimeCard key={anime.id} anime={anime} />
        ))}
      </div>
      
      {(!title && showViewAll && viewAllLink) && (
        <div className={styles.footer}>
          <Link to={viewAllLink} className={styles.viewAllButton}>
            View All <span className={styles.viewAllIcon}>→</span>
          </Link>
        </div>
      )}
    </div>
  );
};

export default AnimeGrid; 